<template>
  <div class="content">
    <div class="downloadHelp" >
      <i class="icon left">&#xe617;</i>
      <a href="/static/高速公路省界门架数据分析终端软件系统使用说明书.pdf" download>帮助PDF</a>
    </div>
    <div class="realName" @click="clickUserName">当前用户：{{realName}}</div>
    <div class="logout" @click="logout">退出</div>

    <base-dialog
      :input="user"
      :rules="{}"
      :width="'600px'"
      :title="'修改密码'"
      :dialogVisible.sync="dialog"
      @submit="confirmClick"
    >
      <el-form-item
        prop="loginPwd" label="新密码"
        :rules="[{required: true, message: '密码不能为空', trigger: 'blur'},{min:1,max:20,message:'字符长度必须在1-20之间',trigger: 'blur'}]">
        <el-input
          clearable v-model="user.loginPwd" for-test="user.loginPwd"
          type="password"
          placeholder="请输入新密码"></el-input>
      </el-form-item>
    </base-dialog>
  </div>
</template>
<style scoped lang="scss">
  .content {
    display: flex;
    font-size: 12px;
    .realName{
      cursor: pointer;
    }
    .logout {
      margin-left: 10px;
      color: #30c0cd;
      cursor: pointer;
    }
    .downloadHelp{
      cursor: pointer;
      color: #30c0cd;
      margin-right: 20px;
      margin-top: -4px;
      .trans{
        width:20px;
        margin-bottom:4px;
      }
      .transword{
        margin-right:10px;
      }
    }
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/business-components/account-info/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/business-components/account-info/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/business-components/account-info/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-business-account-info')
  export default {
    name: 'business-account-info', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'business-account-info': require('%path').default,
       */
      /*start:import components file*/
'base-account-info': require('./../../base-components/account-info/index.vue').default,
       'base-back': require('./../../base-components/back/index.vue').default,
       'base-blackHandle': require('./../../base-components/blackHandle/index.vue').default,
       'base-bottomFloat': require('./../../base-components/bottomFloat/index.vue').default,
       'base-card-header': require('./../../base-components/card-header/index.vue').default,
       'base-carDriverInfo': require('./../../base-components/carDriverInfo/index.vue').default,
       'base-cascader-select-on-click': require('./../../base-components/cascader-select-on-click/index.vue').default,
       'base-check-all': require('./../../base-components/check-all/index.vue').default,
       'base-cropper': require('./../../base-components/cropper/index.vue').default,
       'base-datetimerange': require('./../../base-components/datetimerange/index.vue').default,
       'base-dialog': require('./../../base-components/dialog/index.vue').default,
       'base-empty': require('./../../base-components/empty/index.vue').default,
       'base-export': require('./../../base-components/export/index.vue').default,
       'base-filter': require('./../../base-components/filter/index.vue').default,
       'base-image-carousel': require('./../../base-components/image-carousel/index.vue').default,
       'base-img-base': require('./../../base-components/img-base/index.vue').default,
       'base-img-viewer': require('./../../base-components/img-viewer/index.vue').default,
       'base-key-value': require('./../../base-components/key-value/index.vue').default,
       'base-my-column': require('./../../base-components/my-column/index.vue').default,
       'base-number-input': require('./../../base-components/number-input/index.vue').default,
       'base-plate': require('./../../base-components/plate/index.vue').default,
       'base-quarter-datepicker': require('./../../base-components/quarter-datepicker/index.vue').default,
       'base-simple-menu': require('./../../base-components/simple-menu/index.vue').default,
       'base-yearrange': require('./../../base-components/yearrange/index.vue').default,
       /*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>